'use client'
import HeroCard from '@/components/Cards/HeroCard'
import HeroCategoryCard from '@/components/Cards/HeroCategoryCard'
import { Heading, Slider } from '@/components/Common'
import { NewsArticle } from '@/models/news.model'
import React from 'react'

const Hero = ({ newsList = [] }: { newsList: NewsArticle[] }) => {
  return (
    <section className="container mt-10">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-8 flex flex-col h-auto gap-y-4">
          <Slider data={newsList.slice(0, 6)} isLoading={false} />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-b h-full">
            {newsList.slice(6, 9).map((news) => (
              <div key={news.id} className="col-span-1 md:col-span-1">
                <HeroCard
                  title={news.title}
                  categoryName={news.categoryName}
                  categoryId={news.categoryId}
                  imageUrl={news.imageUrl}
                  link={news.slug}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="col-span-12 lg:col-span-4 hidden lg:block">
          <Heading>Bài Mới nhất</Heading>
          <div className="max-h-[633px] overflow-y-auto">
            <div className="bg-white border border-gray-200 shadow-md p-4 h-full overflow-y-auto">
              {newsList.map((news) => (
                <HeroCategoryCard
                  key={news.id}
                  imageUrl={news.imageUrl}
                  title={news.title}
                  description={news.description}
                  link={news.slug}
                  altText={news.title}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
